import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Button, Card, Space, Spin, Statistic, Typography } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { getApiBaseUrl } from '../../config/env';
import { getUserMonitor } from './api';
import { formatDateTime } from '../../utils/format';

export const CurrentUsers: React.FC = () => {
  const query = useQuery({
    queryKey: ['monitor-users', getApiBaseUrl()],
    queryFn: ({ signal }) => getUserMonitor(signal),
    refetchInterval: 30000,
    retry: false,
  });
  const data = query.isError ? undefined : query.data;

  return <Card size="small" title="Current users" extra={
    <Button icon={<ReloadOutlined />} loading={query.isFetching} onClick={() => query.refetch()}>
      Refresh users
    </Button>
  }>
    <Space direction="vertical" size="middle" className="w-full">
      {query.isPending ? <div role="status" className="flex items-center gap-3"><Spin size="small" />Loading current users…</div> : <>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div>
            <Statistic title="Users online now" value={data?.online_users ?? '-'} />
            <Typography.Text type="secondary">Connected to the backend. Presence expires after 90 seconds.</Typography.Text>
          </div>
          <div>
            <Statistic title="Users playing matches now" value={data?.playing_users ?? '-'} />
            <Typography.Text type="secondary">Human players in active rounds, including disconnected players. Excludes bots and waiting seats.</Typography.Text>
          </div>
        </div>
        <Typography.Text type="secondary">
          Last observed: {data?.observed_at ? formatDateTime(data.observed_at) : '-'} · Refreshes every 30 seconds · Approximate counts
        </Typography.Text>
      </>}
    </Space>
  </Card>;
};
